import React from 'react';
import * as ReactDOM from 'react-dom';
import { Button, Icon, InputItem, Toast } from 'antd-mobile';
import { AddCircleOutline } from 'antd-mobile-icons';
import {post} from '../../utils/request';
import { getUrlParam, href } from '../../utils/util';
import api from './api';

import './index.less';

const NUM_SECTIONS = 10;
const NUM_ROWS_PER_SECTION = 10;
let pageIndex = 0;

let dataBlobs = {};
let sectionIDs = [];
let rowIDs = [];


class WithdrawalBank extends React.Component {
    constructor(...args) {
        super(...args);

        this.state = {
            tabName: 2,
            isLoading: false,
            hasMore: true,
            height: document.documentElement.clientHeight * 10 / 4,
            data: [],
            skipCount: 0,
            pageSize: 10,
            value: null,
            urlOps: {},
            canWithdrawalCash: 0,
            bankName: '',
            bankAccount: '',
            hcAccountBankInfoId: '',
            accountBankCode: '',
            customerName: ''
        };
    }

    viewPort =  () => {
        let u = navigator.userAgent.toLowerCase();
        return {
            isWeixin: u.indexOf('micromessenger') > -1,
            isQQ: u.indexOf('qq/') > -1,
            trident: u.indexOf('trident') > -1, //IE内核
            presto: u.indexOf('presto') > -1, //opera内核
            webKit: u.indexOf('applewebkit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('gecko') > -1 && u.indexOf('khtml') == -1, //火狐内核
            mobile:
                !!u.match(/applewebkit.*mobile.*/) ||
                !!u.match(/applewebkit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( u;)? cpu.+mac os x/), //ios终端
            android: u.indexOf('android') > -1 || u.indexOf('linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iphone') > -1 || u.indexOf('mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('ipad') > -1, //是否iPad
            webApp: u.indexOf('safari') == -1 //是a:否web应该程序，没有头部与底部
        };
    }

    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                // let viewPort = this.viewPort();
                // if (
                //     viewPort.ios ||
                //     viewPort.iPhone ||
                //     viewPort.iPad
                // ) {
                //     if(window.webkit){
                //         window.webkit.messageHandlers.login.postMessage('');
                //     }
                // } else {
                //     if(window.huilian){
                //         window.huilian.login('');
                //     }
                // }
                Toast.fail('您还未登录，请登录后再操作',999);
                return;
            }
            this.setState({
                urlOps: ops
            },()=>{
                this.getDetail(ops)
                this.getBank(ops)
            });
        }
    }

    componentWillMount() {
        this.init()
    }

    init(){
        sectionIDs = [];
        rowIDs = [];
        dataBlobs = {};
        pageIndex = 0;
    }

    setValue(val){
        this.setState({
            value:val
        })
    }


    withdrawal(){
        const {urlOps,detailData,value,bankName,bankAccount,canWithdrawalCash} = this.state;
        if(!value){
            Toast.info('请输入转出金额！',2);
            return
        }
        if(value<5){
            Toast.info('转出金额不能小于5元！',3);
            return
        } else if(value>canWithdrawalCash) {
            Toast.info('转出金额不能大于平安金余额！',2);
            return
        }
        this.setState({isLoading: true})
        post({
            url: api.createCashOutRecord + '?app_stoken=' + urlOps.app_stoken + '&activity=365',
            data: {
                activityCode: urlOps.activityCode,
                cashOutType: '1',
                cashOutAmount: value,
                bankName,
                bankAccount
            }
        }).then((res) => {
            if(res.result === 'success'){
                this.getDetail(urlOps)
                this.setState({ value:'' })
                href(`/withdrawalResult?app_stoken=${urlOps.app_stoken}&activityCode=${urlOps.activityCode}&cashOutType=1`)
            }else{
                href(`/withdrawalResult?app_stoken=${urlOps.app_stoken}&activityCode=${urlOps.activityCode}&cashOutType=0`)
            }
            this.setState({isLoading: false})
        }, (res)=>{
            Toast.info('提现失败',1);
            this.setState({isLoading: false})
        });
    }

    getBank(ops) {
        post({
            url: api.selectBankInfoList + '?app_stoken=' + ops.app_stoken + '&activity=365',
            data:{
            }
          }).then((res) => {
              if(res.result === 'success' && res.data && res.data.length>0){
                console.log(res)
                this.setState({
                    bankAccount: res.data[0].bankAccount,
                    bankName: res.data[0].accountBankName,
                    hcAccountBankInfoId: res.data[0].hcAccountBankInfoId,
                    accountBankCode: res.data[0].accountBankCode,
                    customerName: res.data[0].customerName
                })
              } else {
                this.setState({bankAccount:'',bankName: ''})
              }
          }, (res)=>{
              console.log('查询失败', res)
          });
    }

    getDetail(ops) {
        post({
            url: api.pinganActivityUserCash + '?app_stoken=' + ops.app_stoken + '&activity=365',
            data:{
            }
          }).then((res) => {
              if(res.result === 'success' && res.data){
                this.setState({canWithdrawalCash: res.data.canWithdrawalCash})
              }
          }, (res)=>{
              console.log('查询失败', res)
          });
    }

    render() {
        const {data, urlOps, value, canWithdrawalCash, bankName,hcAccountBankInfoId,accountBankCode,customerName,bankAccount, isLoading} = this.state;
        
        return (
            <div>
                <div className='lightGreen'>
                    {bankName==''?<a onClick={()=>{href(`/bindBank?app_stoken=${urlOps.app_stoken}&activityCode=${urlOps.activityCode}`);}}>
                        <AddCircleOutline style={{ width: '0.2rem', height: '0.2rem', color: '#009F90', position: 'absolute', top: '1.05rem', left: '1rem' }} />
                        <span style={{ color: '#009F90', fontSize: '0.18rem', left: '1.28rem', top: '1.54rem' }}>添加银行卡</span>
                    </a>:
                    <div>
                        <span style={{ color: '#333', fontSize: '0.18rem', position: 'absolute', left: '0.35rem', top: '1.56rem' }}>{bankName.split('银行')[0]+'银行'}</span>
                        <a style={{ color: '#009F90', fontSize: '0.14rem', position: 'absolute', top: '1.1rem', right: '0.3rem' }} onClick={()=>{href(`/bindBank?app_stoken=${urlOps.app_stoken}&activityCode=${urlOps.activityCode}&hcAccountBankInfoId=${hcAccountBankInfoId}&accountBankCode=${accountBankCode}&customerName=${customerName}&accountBankName=${bankName}&bankAccount=${bankAccount}`)}}>修改</a>
                    </div>}
                </div>
                <div className='tipContent'>
                    <span className='left'>转出金额</span>
                </div>
                <div className='inputContent'>
                    <span>￥</span>
                    <InputItem
                        placeholder='最低可提现5元'
                        value={value}
                        onChange={val => {
                            this.setValue(val)
                        }}
                    />
                </div>
                <div className='tipContent'>
                    <span className='left' style={{ marginRight: '0.11rem' }}>我的平安金：</span><span className='left'>￥{canWithdrawalCash}</span>
                    <span className='right'><a style={{ color: '#009F90' }} onClick={()=>this.setValue(canWithdrawalCash)}>全部转出</a></span>
                </div>
                <Button className='button' loading={isLoading} onClick={()=>this.withdrawal()}>提交申请</Button>
                <div className='content'>
                <p>提现规则：</p>
                    <p>1、平安金支持提现至充电卡账户和银行卡，其中提现到充电卡账户的额度比直接提现到个人银行卡账户将多10%额度上浮。</p>
                    <p>2、充电卡账户提现实时到账，银行卡账户提现将于提交申请后一周内到账，且至少满5元方可提现。</p>
                    <p>3、首次提现到银行卡时需要添加银行卡信息，请务必准确填写姓名、开户行、银行账号等信息，如因填写错误造成的损失由申请人自行承担。</p>
                    <p>4、温馨提示：开户行是指办理银行开户手续的营业网点，如有疑惑，可拨打发卡行的客服热线或前往银行网点查询。</p>
                </div>
                <a className='bottom' onClick={()=>{href(`/withdrawalRecordsList?app_stoken=${urlOps.app_stoken}&cashOutType=1`)}}>提现记录</a>
            </div>
        );
    }
}
export default WithdrawalBank;


// WEBPACK FOOTER //
// ./src/withdrawal/index/bank.js